import React from "react";
import { Form, DatePicker } from "antd";
import moment from "moment";

const dateFormat = "DD/MM/YYYY";

const UserDetailDOB = (props) => {
  // -------------------------- VAR --------------------------
  const { disabled } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Form.Item
      initialValue={moment("01/01/2000", dateFormat)}
      name="dob"
      label="Date of Birth"
      rules={[
        {
          required: true,
          message: "Please input date of birth",
        },
      ]}
    >
      <DatePicker format={dateFormat} style={{ width: "100%" }} disabled={disabled} />
    </Form.Item>
  );
};

export default UserDetailDOB;
